export enum CollectionTypeCode {
  TariffDownPayment = 'tariffDownPayment', // Abono de Arancel (credito)
  Tariff = 'tariff', // Arancel Completo (contado)
  Quota = 'quota', // Cuota de Arancel (credito)
  Matriculation = 'matriculation', // Matricula
}
